import React from "react";
import type { IAppUpload } from "./AppUpload";
import { UploadContentComponent } from "./content/UploadContentComponent";
import { AppComponent } from "../shared-components/AppComponent";
import { OopsPageErrorCatchingComponent } from "../shared-components/error-catching-component/OopsPageErrorCatchingComponent";

interface IUploadMasterMasterComponentProps {
    appUpload: IAppUpload;
}

export class UploadMasterComponent extends React.Component<IUploadMasterMasterComponentProps> {
    componentDidMount() {
        window.onbeforeunload = this.onBeforeUnload;
    }

    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    onBeforeUnload = (e: BeforeUnloadEvent) => {
        const { stores } = this.props.appUpload;
        const { uploadStore } = stores;

        if (uploadStore.somethingIsUploading) {
            e.preventDefault();
        }
    };

    render() {
        const { appUpload } = this.props;
        const { stores } = appUpload;

        return (
            <OopsPageErrorCatchingComponent isLandingPage={true}>
                <AppComponent appStores={stores}>
                    <UploadContentComponent />
                </AppComponent>
            </OopsPageErrorCatchingComponent>
        );
    }
}
